var spiceControls = {

    sc: null,

    connected: false,

    controlButton: $('#startButton'),

    connect: function() {
        var host, port, password, scheme = "ws://", uri;

        if (window.location.protocol === 'https:') {
            scheme = 'wss://';
        }

        host = document.getElementById("host").value;
        port = document.getElementById("port").value;
        password = document.getElementById("password").value;

        if ((!host) || (!port)) {
            console.log("must set host and port");
            return;
        }

        if (this.sc) {
            this.sc.stop();
        }

        uri = scheme + host + ":" + port;

        this.controlButton.find('.text').text('Stop');
        this.controlButton.removeClass('btn-success').addClass('btn-danger');

        try {
            this.sc = new SpiceMainConn({
                uri: uri,
                screen_id: "spice-screen",
                dump_id: "debug-div",
                message_id: "message-div",
                password: password,
                onerror: this.spice_error
            });
            this.connected = true;
        } catch (e) {
            alert(e.toString());
            this.disconnect();
        }
    },

    disconnect: function () {
        if (this.sc) {
            this.sc.stop();
            this.sc = null;
        }

        this.connected = false;
        this.controlButton.find('.text').text('Start');
        this.controlButton.removeClass('btn-danger').addClass('btn-success');
    },

    spice_error: function (e) {
        this.disconnect();
    }

};

$(document).ready(function() {
    var spice = spiceControls,
        inactivity,
        baseUrl = $('body').data('base-url');

    function updateStatus(status) {
        $.post(
            baseUrl + '/vm/action/use',
            {
                port: $('#port').val(),
                status: status
            }
        );
    }

    inactivity = new Inactivity(function() {
        updateStatus('stop');
    });

    $('#startButton').click(function(e) {
        if (spice.connected) {
            inactivity.destroy();
            spice.disconnect();
            updateStatus('stop');
        } else {
            inactivity.init();
            spice.connect();
            updateStatus('start');
        }

        e.preventDefault();
    });

});
